<template>
  <eventi-view-component :jsonData="jsonData" :pathResource="pathResource" :utente="utente" :titoloEvento="titoloEvento" :linkPrintData="linkPrintData" :isImmagini="false" :isAllegati="false" :isPrestazioni="true" :btnFirmaVisible="btnFirmaVisible" @updateFirma="onFirmaUpdate">
    <template slot="tab-content-event">
      <enteroscopia-view-component @update="onUpdateJsonData" :idEvento="id" :key="enteroscopiaViewKey"></enteroscopia-view-component>
    </template>
  </eventi-view-component>
</template>

<script>
// import axios from "axios";
import EventiViewComponent from "../../../base/components/EventiViewComponent.vue";
import EventiMixin from "../../../utility/mixins/EventiMixins";
import UtilityMixin from "../../../../../utility/UtilityMixin";
import EnteroscopiaViewComponent from "../components/EnteroscopiaViewComponent.vue";
export default {
  components: { EventiViewComponent, EnteroscopiaViewComponent },
  mixins: [UtilityMixin, EventiMixin],
  props: {
    utente: {
      type: Object,
      default: function () {
        return null;
      },
    },
  },
  data() {
    return {
      titoloEvento: "ENTEROSCOPIA",
      linkback: null,
      linkedit: null,
      jsonData: {},
      btnFirmaVisible: true,
      pathResource: "/gastroenteroscopia",
      tabIndex: 0,
      id: null,
      pathRestValidation: "/validation",
      isThisFirmato: false,
      showModalLoading: false,
      linkPrintData: null,
      enteroscopiaViewKey: 0,
    };
  },
  computed: {
    idPaziente() {
      return this.$route.query.idPaziente;
    },
    linkPatient() {
      return EventiMixin.getLinkPatient(this.utente, this.idPaziente);
    },
  },
  mounted() {
    let me = this;
    me.jsonData.idPaziente = this.$route.query.idPaziente;
    me.id = this.$route.params.id;
    me.enteroscopiaViewKey++;
  },

  methods: {
    updateStatoFirma(firmato) {
      console.log(firmato);
    },
    onFirmaUpdate() {
      let me = this;
      me.btnFirmaVisible = false;
      me.enteroscopiaViewKey++;
    },
    onUpdateJsonData(data) {
      let me = this;
      me.jsonData = data;
      if (me.jsonData.firma) {
        me.btnFirmaVisible = false;
      } else {
        me.btnFirmaVisible = true;
      }
      me.linkPrintData = "/pazienteeventi/print/" + me.jsonData.id;
    },
  },
};
</script>

<style></style>
